
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scb-pp-us",
      function () {
        return require("private-next-pages/scb-pp-us/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scb-pp-us"])
      });
    }
  